var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#000000;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:3;}\n")), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11,19L6.4,4.5C6.2,3.6,5.3,3,4.4,3H2",
    id: "id_101",
    style: {
      stroke: "rgb(237, 1, 1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26,23H8.4c-1.1,0-2-0.9-2-2v0c0-1.1,0.9-1.8,2-2L29,16V6H11",
    id: "id_102",
    style: {
      stroke: "rgb(237, 1, 1)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 11,
    cy: 28,
    r: 1,
    id: "id_103",
    style: {
      stroke: "rgb(237, 1, 1)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 24,
    cy: 28,
    r: 1,
    id: "id_104",
    style: {
      stroke: "rgb(237, 1, 1)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartRed);
export default __webpack_public_path__ + "static/media/cart_red.c523e0285c791a35fcfc3d91ab54f6b4.svg";
export { ForwardRef as ReactComponent };